import React from 'react';
import '../../../home-page/sections/Industries/industries.scss';
import {Button} from "../../../../components";
import {IndustryDataType} from 'models';
import {useNavigate} from "react-router-dom";


interface Props extends IndustryDataType {
}

export const Industry: React.FC<Props> = ({heading, description, image, cards, paragraph}) => {
    const navigate = useNavigate()
    return (
        <div className={'industry-section'} id={']industry-section_wrapper_id'}>

            <div className="industry-section_wrapper">
                <div className="industry-section_wrapper_left">
                    <h1>{heading}</h1>
                    <p>{description}</p>
                    <div className="industry-section_wrapper_left_img">
                        <img src={image} alt=""/>
                    </div>
                    <p>{description}</p>
                </div>

                <div className="industry-section_wrapper_right">
                    <h1>Industry Description</h1>
                    <br/>
                    {paragraph}
                </div>

                <div className="industry-section_wrapper_cards">
                    {
                        cards.map(({image: cardImage},index) => (
                            <div key={index} className="industry-section_wrapper_cards_card">
                                <img src={cardImage} alt=""/>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className="industry-section_footer">
                <p>{description}</p>
                <div className="industry-section_footer_cta">
                    <Button text={'Become A Member Now'} type={'primary'} onclick={()=>navigate('/registration/')}/>
                </div>

            </div>
        </div>
    );
};

